// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2LvSA","upload":"Small_upload__lFQli","imageWrap":"Small_imageWrap__gukLZ","removeBtn":"Small_removeBtn__2lZCq"};